import React, { useEffect, useState, useRef, useContext } from 'react'
import { GlobalContext } from '../../../Store/GlobalContext'
import GetTeamLogo from '../../Network/GET/ApplyNowLogo'
import './Header.css'

const Header = ( props ) => {
    // const { globalValues, globalDispatch } = useContext( GlobalContext )
    const [ logoSrc, setLogoSrc ] = useState( '' )

    useEffect( () => {
        getTeamLogo()
    },[])

    // useEffect( () => {
    //     if( globalValues.teamLogo !== '' ){
    //         setLogoSrc( `data:image/gif;base64,${globalValues.teamLogo}` )
    //     }
    // }, [globalValues.teamLogo])

    const getTeamLogo = () => {
        if( logoSrc === '' ){
            GetTeamLogo()
            .then( res => {
                setLogoSrc( `data:image/gif;base64,${res}` )
                // globalDispatch({
                //     type : 'SET_TEAM_LOGO',
                //     payload : res
                // })
            })
        }
    }

    return (
        <div id='floify-header' className="cf">
            <div id="floify-header-inner" className="cf">
                <div id="floify-header-logo">
                    { logoSrc !== '' &&
                        <a href="/">
                            <img src={ logoSrc } alt="Company Logo" />
                        </a>
                    }
                </div>

                <div id="floify-header-right">
                    { props.profile &&
                        <div>
                            <p><a href="/profile-edit">Back to Profile</a></p>
                        </div>
                    }
                    { props.showLogin &&
                        <div>
                            <p>Have an account?</p>
                            <a className="lp-button buttonHover whiteButton" href="/login">Log In</a>
                        </div>
                    }
                    { props.showRegister &&
                        <div>
                            <p>Don't have an account?</p>
                            <a className="lp-button buttonHover" href="/apply-now">Apply Now</a>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Header